import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import Header from './component'

import { updateSelectedRound } from '../../../redux/game'
import { toggleSidebar } from '../../../redux/ui'

class HeaderContainer extends PureComponent {
  handleMinimiseSidebar = () => {
    this.props.toggleSidebar()
  }

  handleRoundSelect = (round) => this.props.updateSelectedRound(round)

  render () {
    if (this.props.isLoading) {
      return (
        <Header
          onMinimiseSidebar={this.handleMinimiseSidebar}
          sidebarMinimised={this.props.sidebarMinimised}
          isWrapUp={this.props.isWrapUp}
        />
      )
    }
    return (
      <Header
        onMinimiseSidebar={this.handleMinimiseSidebar}
        sidebarMinimised={this.props.sidebarMinimised}
        rounds={this.props.rounds}
        onRoundSelect={this.handleRoundSelect}
        isWrapUp={this.props.isWrapUp}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  sidebarMinimised: state.ui.sidebarMinimised,
  rounds: {
    count: state.game.totalRounds,
    current: state.game.currentRound,
    selected: state.game.selectedRound
  },
  isWrapUp: state.game.state === 'wrapup'
})

export default connect(mapStateToProps, { toggleSidebar, updateSelectedRound })(HeaderContainer)
